module.exports = {"Operate1":{"daobanList":[{"title":"1:是否办理食品经营许可证核发（实施申请人承诺制的小餐饮）","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、《食品经营许可证》核发申请书","state":"必要"},{"name":"2、食品安全管理员身份证明","state":"必要"},{"name":"3、委托书及代理人身份证明","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/sdo-1.json
// module id = 1267
// module chunks = 0